exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._1bRXe8jpCecfIsYleZWLSI {\n  display: flex;\n  margin-bottom: 12px;\n}\n\n._3hTmlPu-3XHxjSwQdrk-FI {\n  flex: 1;\n  display: flex;\n}\n\n._14RqjXSAYhzIvcPPM_jEM4 {\n}\n", "", {"version":3,"sources":["/home/forge/vf.leadpm.io/frontend/src/Screens/SubProject/Components/SubInvoices/Components/Header/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAoB;CACrB;;AAED;EACE,QAAQ;EACR,cAAc;CACf;;AAED;CACC","file":"styles.css","sourcesContent":[".wrapper {\n  display: flex;\n  margin-bottom: 12px;\n}\n\n.left {\n  flex: 1;\n  display: flex;\n}\n\n.right {\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"wrapper": "_1bRXe8jpCecfIsYleZWLSI",
	"left": "_3hTmlPu-3XHxjSwQdrk-FI",
	"right": "_14RqjXSAYhzIvcPPM_jEM4"
};